import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'GuideOrder',
  //   description: 'description of GuideOrder',
  //   url: '/guide-order',
  // },
];

export default help;
